/**
 * Slim platform footer — closes the panel with the landing's "Una plataforma de
 * mesaches" signature (the mesaches wordmark image) plus the legal line. Shared
 * by the tenant {@link Layout} and the admin shell.
 */
export function Footer(): JSX.Element {
  return (
    <footer className="flex flex-none flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t border-slate-200 bg-white px-4 py-3 text-xs text-slate-400 sm:px-6">
      <a
        href="https://mesaches.com"
        target="_blank"
        rel="noopener noreferrer"
        title="mesaches.com"
        className="group flex items-center gap-2"
      >
        <span className="font-mono text-[10px] uppercase tracking-wider text-slate-400">
          Una plataforma de
        </span>
        <img
          src="/mesaches-logo.png"
          alt="mesaches"
          className="h-4 w-auto opacity-80 transition group-hover:scale-[1.04] group-hover:opacity-100"
        />
      </a>
      <div className="flex items-center gap-4">
        {/* Plain anchor, not a router Link: /docs is a separate public shell, so a full navigation
            leaves the authenticated bundle behind instead of loading it alongside the docs. */}
        <a href="/docs" className="font-mono transition-colors hover:text-primary">
          Documentación API
        </a>
        <span className="font-mono">© 2026 MESACHES DESARROLLOS INFORMATICOS S.L.</span>
      </div>
    </footer>
  );
}
